<template>
  <div>
    <div v-if="loading" class="loading">
      <SvgLoaderMoon> </SvgLoaderMoon>
    </div>
    <div v-else>
      <div class="rights-management__header u-margin-bottom-small">
        <BackButton> </BackButton>
      </div>
      <div class="rights-management__body">
        <div class="row">
          <div class="w-full">
            <card class="card" title="Roles">
              <!-- Content Part -->

              <div class="card__right-button">
                <div class="position-relative">
                  <button class="btn btn-just-icon btn-outline-warning mr-3 tooltipBtn" @click="openCreate = true">
                    <i class="fas fa-plus" />
                  </button>
                  <div class="tooltipCustom tooltipCustom--bottom">Create new Role</div>
                </div>
              </div>

              <div v-if="roles.length > 0">
                <div v-for="role in roles" v-bind:key="role.data.role_id">
                  <div class="row">
                    <div class="col-1-of-4">
                      <label for="role_name" class="control-label">Role</label>
                      <p id="role_name" class="text-title">{{ role.data.name }}</p>
                    </div>

                    <div class="col-2-of-4">
                      <label for="description" class="control-label">Description</label>
                      <p id="description" class="description">{{ role.data.description }}</p>
                    </div>

                    <div v-if="checkScopes('updateSystemRole')" class="col-1-of-4 mt-2">
                      <router-link :to="'/roles/' + role.data.role_id">
                        <p-button type="success" outline icon>
                          <i class="fa fa-edit" />
                        </p-button>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else>
                <p>{{ $t('this_company_does_not_have_any_roles') }}</p>
              </div>
              <!-- End Content Part -->
            </card>
          </div>
        </div>
      </div>
    </div>

    <ModalTemplate
      component-name="CreateRoleModal"
      action="addSystemRole"
      button-component-name="CreateNewButton"
      :data="{
        header: $t('create_new_role'),
      }"
      @submit="updateRolesList($event)"
      :clicked="openCreate"
      @update:field="openCreate = false"
    >
    </ModalTemplate>
  </div>
</template>

<script>
import CreateRoleModal from '../../../components/modals/CreateRoleModal';
import axiosAuth from '../../../axiosMain';
import EditButton from '../../../components/buttons/EditButton';
import SvgLoaderMoon from '../../../components/svg/SvgLoaderMoon';
import BackButton from '../../../components/buttons/BackButton';
import ModalTemplate from '../../../components/modals/ModalTemplate';
import scopesChecker from '../../../router/scopes/scopesChecker';
export default {
  name: 'RightsManagementIndex',
  components: { ModalTemplate, BackButton, EditButton, CreateRoleModal, SvgLoaderMoon },
  data: function () {
    return {
      roles: {},
      loading: true,
      openCreate: false,
    };
  },
  mounted() {
    axiosAuth
      .get('/company_roles/' + this.$store.getters.user.company.data.company_id, {
        headers: {
          Authorization: 'Bearer ' + this.$store.getters.token,
        },
      })
      .then((response) => {
        this.roles = response.data.data;
        this.loading = false;
      })
      .catch((errors) => {
        this.loading = false;
        this.$notify({
          type: 'error',
          title: this.$t('Error') + ' ' + errors.response.status,
          text: errors.response.data,
        });
      });
  },
  methods: {
    checkScopes: function (action) {
      return scopesChecker(null, this.$route.name, action);
    },
    updateRolesList: function (event) {
      this.roles.push(event);
    },
  },
};
</script>

<style scoped></style>
